import { Component, Inject, OnInit, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { RideEdits } from 'src/app/interfaces';
import { DialogData } from '../ride-details/ride-details.component';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from 'src/app/app.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDivider } from '@angular/material/list';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-ride-edits',
  templateUrl: './ride-edits.component.html',
  styleUrls: ['./ride-edits.component.scss'],
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    MatDivider,
    DatePipe,
  ],
})
export class RideEditsComponent implements OnInit {
  allEdits = signal<RideEdits[]>([]);
  notEdited = false;
  Object = Object;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  async ngOnInit() {
    const editsQuery = query(
      collection(
        db,
        `organisations/${localStorage.getItem('orgId')}/rides/${this.data.ride.id}/edits`,
      ),
      orderBy('date', 'desc'),
    );
    const edits = (await getDocs(editsQuery)).docs.map((doc) => doc.data() as RideEdits);
    this.allEdits.set(edits);
  }
}
